export default {
  A3: 0,
  A4: 1,
};
